module.exports = __webpack_public_path__ + "static/media/ci-logo.b101f7bc.png";